export const CustomerChatbotDependencyTypes = {
  CustomerChatbotApiService: Symbol.for('CustomerChatbotApiService'),
  CustomerChatbotVisitorIdentificationApiDataTransformer: Symbol.for(
    'CustomerChatbotVisitorIdentificationApiDataTransformer',
  ),
  CustomerChatbotRepository: Symbol.for('CustomerChatbotRepository'),
  HubspotConversationsWidgetService: Symbol.for('HubspotConversationsWidgetService'),
  CustomerChatbotService: Symbol.for('CustomerChatbotService'),
};
